/* globals VXConfig */

import PropTypes from 'prop-types';
import GlobalSearchDropdownRow from './GlobalSearchDropdownRow';
import ReloadHelper from '../../utils/ReloadHelper';
import Translations from '../../utils/Translations';
import Flux from '../../flux/Flux';
import { generateKey } from '../../utils/CommonUtils';
import { Component } from 'react';

const TYPES = {
	ACTOR: 'actor',
	PHOTO: 'photo',
	VIDEO: 'video',
	MEDIATHEK: 'mediathek',
	BLOG: 'blog',
};

class GlobalSearchDropdown extends Component {
	constructor(props) {
		super(props);

		this.onClickAllResults = this.onClickAllResults.bind(this);
		this.validResult = this.validResult.bind(this);

		// sub-components
		this.getSuggestions = this.getSuggestions.bind(this);
		this.getPreviousSearches = this.getPreviousSearches.bind(this);
		this.getProposals = this.getProposals.bind(this);
		this.getResultRow = this.getResultRow.bind(this);
		this.getAllResultsButton = this.getAllResultsButton.bind(this);
		this.getNoResultPage = this.getNoResultPage.bind(this);
	}

	onClickAllResults(e) {
		this.props.onAllResultsClick(e);
	}

	validResult() {
		return (
			(this.props.actorsSearchResult && this.props.actorsSearchResult.count > 0) ||
			(this.props.videosSearchResult && this.props.videosSearchResult.count > 0) ||
			(this.props.blogSearchResult && this.props.blogSearchResult.count > 0) ||
			(this.props.mediathekSearchResult && this.props.mediathekSearchResult.count > 0)
		);
	}

	getSuggestions() {
		const content = [];

		content.push(
			<div key={generateKey('global_search-dropdown-headline', content.length)} className={'global_search-dropdown-headline'}>
				<span>{Translations.get('GlobalSearchSuggestionsQuestion').toUpperCase()}</span>
			</div>,
		);

		for (let i = 0; i < this.props.suggestions.length; i++) {
			const onClick = (e) => {
				ReloadHelper.reload(this.props.suggestions[i].targetUrl, e);
				this.props.onElementClick(false);
			};

			content.push(
				<div key={generateKey('global_search-text-row', i)} className={'global_search-dropdown-text-row'}>
					<button onClick={onClick} className={'global_search-dropdown-clickable'}>
						{this.props.suggestions[i].name}
					</button>
				</div>,
			);
		}

		return (
			<div key={generateKey('global_search-suggestions')} className={'global_search-dropdown-suggestions'}>
				{content}
			</div>
		);
	}

	getPreviousSearches() {
		const content = [];

		if (this.props.lastSearchRequests.length > 0) {
			content.push(
				<div key={generateKey('global_search-headline', content.length)} className={'global_search-dropdown-headline'}>
					<span>
						<span className={'icon -icon-round-time-line global_search-dropdown-headline-icon'} />
						{Translations.get('GlobalSearchPreviousQuestion').toUpperCase()}
					</span>
				</div>,
			);

			for (let i = 0; i < this.props.lastSearchRequests.length; i++) {
				const onClick = (e) => {
					this.props.onLastSearchClick(this.props.lastSearchRequests[i], e);
				};
				content.push(
					<div key={generateKey('global_search-text-row', i)} className={'global_search-dropdown-text-row'}>
						<button onClick={onClick} className={'global_search-dropdown-clickable'}>
							{this.props.lastSearchRequests[i]}
						</button>
					</div>,
				);
			}
		}

		return (
			<div key={generateKey('global_search-previous')} className={'global_search-dropdown-previous'}>
				{content}
			</div>
		);
	}

	getProposals() {
		const proposals = [];
		for (let i = 0; i < this.props.proposals.length; i++) {
			const onClick = (e) => {
				this.props.onProposalClick(this.props.proposals[i], e);
			};

			const proposal = this.props.proposals[i];

			const p1 = proposal.substr(0, this.props.searchPattern.length);
			const p2 = proposal.substr(this.props.searchPattern.length);

			proposals.push(
				<button
					key={generateKey('global_search-proposal', proposals.length)}
					className={'global_search-dropdown-proposals-proposal'}
					onClick={onClick}
				>
					<span className={'global_search-dropdown-proposals-proposal-highlight'}>{p1}</span>
					{p2}
				</button>,
			);
		}

		return proposals.length > 0 ? (
			<div key={generateKey('global_search-proposals', proposals.length)} className={'global_search-dropdown-proposals'}>
				<div className={'global_search-dropdown-proposals-headline'}>Vorgeschlagene Suchanfragen</div>
				{proposals}
			</div>
		) : null;
	}

	getResultRow(type) {
		let title,
			count = 0,
			link,
			items = [];
		const isSexole = Flux.Browser.isSexole();
		const isSpanish = VXConfig.language === Flux.Constants.Languages.ES;

		switch (type) {
			case TYPES.ACTOR:
				title = Translations.get('CollectionSearchResultsActors');
				count = this.props.actorsSearchResult.count;
				link = this.props.actorsSearchResult.link;
				items = this.props.actorsSearchResult.items.slice(0, 3);
				break;
			case TYPES.VIDEO:
				title = 'Videos';
				count = this.props.videosSearchResult.count;
				link = this.props.videosSearchResult.link;
				break;
			case TYPES.MEDIATHEK:
				if (!(isSexole || isSpanish)) {
					title = 'TV';
					count = this.props.mediathekSearchResult.count;
					link = this.props.mediathekSearchResult.link;
				}
				break;
			case TYPES.BLOG:
				if (!(isSexole || isSpanish)) {
					title = 'Blog';
					count = this.props.blogSearchResult.count;
					link = this.props.blogSearchResult.link;
				}
				break;
			default:
				return null;
		}

		if (count > 0) {
			return (
				<GlobalSearchDropdownRow
					searchPattern={this.props.searchPattern}
					key={generateKey('result-row' + type)}
					title={title}
					count={count}
					allLink={link}
					items={items}
					onElementClick={this.props.onElementClick}
				/>
			);
		} else {
			return null;
		}
	}

	getNoResultPage() {
		return (
			<div key={generateKey('global_search-noresult')} className={'global_search-dropdown-container'}>
				<div className={'global_search-dropdown-noresult-first'}>{Translations.get('navigation.search_noresult-first')}</div>
				<div className={'global_search-dropdown-noresult-sec'}>{Translations.get('navigation.search_noresult-second')}</div>
			</div>
		);
	}

	getAllResultsButton() {
		return (
			<div key={generateKey('global_search-all-button')} className={'global_search-dropdown-all-button'}>
				<button onClick={this.onClickAllResults} className={'button -btn-color-special -click-material'}>
					{Translations.get('GlobalSearchPreviousAll')}
				</button>
			</div>
		);
	}

	render() {
		const content = [];

		if (this.props.postSearch) {
			if (this.validResult()) {
				content.push(this.getProposals());
				content.push(this.getResultRow(TYPES.ACTOR));
				content.push(this.getResultRow(TYPES.VIDEO));
				content.push(this.getResultRow(TYPES.PHOTO));
				content.push(this.getResultRow(TYPES.MEDIATHEK));
				content.push(this.getResultRow(TYPES.BLOG));
				content.push(this.getAllResultsButton());
			} else {
				content.push(this.getNoResultPage());
			}
		} else {
			content.push(this.getSuggestions());
			content.push(this.getPreviousSearches());
		}

		return <div className={'global_search-dropdown'}>{content}</div>;
	}
}

GlobalSearchDropdown.propTypes = {
	postSearch: PropTypes.bool,
	suggestions: PropTypes.arrayOf(
		PropTypes.shape({
			name: PropTypes.string,
			targetUrl: PropTypes.string,
		}),
	),
	lastSearchRequests: PropTypes.arrayOf(PropTypes.string),
	topResult: PropTypes.shape({
		type: PropTypes.string,
		link: PropTypes.string,
		title: PropTypes.string,
		previewPicture: PropTypes.string,
	}),
	proposals: PropTypes.array,
	mediathekSearchResult: PropTypes.shape({
		count: PropTypes.number,
		link: PropTypes.string,
	}),
	actorsSearchResult: PropTypes.shape({
		count: PropTypes.number,
		link: PropTypes.string,
		items: PropTypes.arrayOf(
			PropTypes.shape({
				name: PropTypes.string,
				imageUrl: PropTypes.string,
				imageAspect: PropTypes.number,
				link: PropTypes.string,
				online: PropTypes.bool,
			}),
		),
	}),
	videosSearchResult: PropTypes.shape({
		count: PropTypes.number,
		link: PropTypes.string,
	}),
	blogSearchResult: PropTypes.shape({
		count: PropTypes.number,
		link: PropTypes.string,
	}),
	onElementClick: PropTypes.func,
	onLastSearchClick: PropTypes.func,
	onAllResultsClick: PropTypes.func,
	onProposalClick: PropTypes.func,
	searchPattern: PropTypes.string,
};

GlobalSearchDropdown.defaultProps = {
	postSearch: false,
};

export default GlobalSearchDropdown;
